import formatName from 'I18n/utils/formatName';
import { fromJS, List, Map as ImmutableMap, OrderedMap } from 'immutable';
import { fetchUsersSearchPage, getUsersByIds
// @ts-expect-error untyped module reference-resolvers
} from 'reference-resolvers/api/UsersAPI';
// @ts-expect-error untyped module reference-resolvers
import { createUserGenericPageReferenceResolver } from 'reference-resolvers/resolvers/UserGenericPagedReferenceResolver';
// @ts-expect-error untyped module reference-resolvers
import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
import { fetchAssignableUserIds, fetchDeactivatedUserIds } from 'automation-ui-action-features/users-and-teams/usersApi';
export const ASSIGNABLE_USER = 'ASSIGNABLE_USER';
export const LEGACIED_ASSIGNABLE_USER = 'LEGACIED_ASSIGNABLE_USER';
export const formatAssignableUsersSearchPaged = ({
  usersSearchResult = {},
  assignableUserIds,
  deactivatedUserIds
} = {}) => {
  const {
    hasMore,
    offset,
    results = []
  } = usersSearchResult;
  const assignableUsers = List(results.map(user => Object.assign({}, user, {
    firstName: user.first_name,
    id: user.user_id,
    isAssignable: Array.isArray(assignableUserIds) ? assignableUserIds.includes(user.user_id) : true,
    // No ids indicates all users are assignable.
    isDeactivated: Array.isArray(deactivatedUserIds) ? deactivatedUserIds.includes(user.user_id) : false,
    lastName: user.last_name
  })).map(user => new ReferenceRecord({
    description: user.email,
    disabled: user.isDeactivated || !user.isAssignable,
    id: String(user.id),
    label: formatName({
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email
    }),
    referencedObject: fromJS(user)
  })));
  return ImmutableMap({
    count: assignableUsers.size,
    hasMore,
    offset: offset || 0,
    results: assignableUsers
  });
};
export const formatAssignableUsersByIds = ({
  usersById = OrderedMap(),
  assignableUserIds,
  deactivatedUserIds
} = {}) => usersById.map(referenceRecord => {
  const userId = Number.parseInt(referenceRecord.get('id'), 10);
  const user = referenceRecord.get('referencedObject').merge({
    isAssignable: Array.isArray(assignableUserIds) ? assignableUserIds.includes(userId) : true,
    // No ids indicates all users are assignable.
    isDeactivated: Array.isArray(deactivatedUserIds) ? deactivatedUserIds.includes(userId) : false
  });
  return referenceRecord.merge({
    disabled: user.get('isDeactivated') || !user.get('isAssignable'),
    referencedObject: user
  });
});
const getAssignableUsersSearchPage = props => Promise.all([fetchUsersSearchPage(props), fetchAssignableUserIds(), fetchDeactivatedUserIds()]).then(([usersSearchResult, assignableUserIds, deactivatedUserIds]) => formatAssignableUsersSearchPaged({
  usersSearchResult,
  assignableUserIds,
  deactivatedUserIds
}));
const getAssignableUsersByIds = ids => Promise.all([getUsersByIds(ids), fetchAssignableUserIds(), fetchDeactivatedUserIds()]).then(([usersById, assignableUserIds, deactivatedUserIds]) => formatAssignableUsersByIds({
  usersById,
  assignableUserIds,
  deactivatedUserIds
}));
const getLegaciedAssignableUsersSearchPage = props => Promise.all([fetchUsersSearchPage(props), fetchDeactivatedUserIds()]).then(([usersSearchResult, deactivatedUserIds]) => formatAssignableUsersSearchPaged({
  usersSearchResult,
  deactivatedUserIds
}));
const getLegaciedAssignableUsersByIds = ids => Promise.all([getUsersByIds(ids), fetchDeactivatedUserIds()]).then(([usersById, deactivatedUserIds]) => formatAssignableUsersByIds({
  usersById,
  deactivatedUserIds
}));
export const AssignableUserResolver = createUserGenericPageReferenceResolver({
  fetchByIds: getAssignableUsersByIds,
  fetchSearchPage: getAssignableUsersSearchPage
});
export const LegaciedAssignableUserResolver = createUserGenericPageReferenceResolver({
  fetchByIds: getLegaciedAssignableUsersByIds,
  fetchSearchPage: getLegaciedAssignableUsersSearchPage
});
export default AssignableUserResolver;